import React, { useState } from 'react';
import { Waypoint } from 'react-waypoint';

import { GradientListBottom, GradientListTop, StyledContainer } from './GradientList.styles';

type GradientListProps = {
  children: React.ReactNode;
};

type GradientListState = {
  gradientBottom: boolean;
  gradientTop: boolean;
};

/**
 * This components receives things to render.
 * It will render this elements in a scrollable list, and render a
 * gradient if there are more elements to see up or down in the list
 */
export const GradientList: React.FC<GradientListProps> = ({ children }: GradientListProps) => {
  const [state, setState] = useState<GradientListState>({
    gradientBottom: true,
    gradientTop: false,
  });

  const onTopWaypoint = ({ currentPosition }: Waypoint.CallbackArgs) => {
    if (currentPosition === 'inside') {
      setState({
        ...state,
        gradientTop: false,
      });
    } else if (currentPosition === 'above') {
      setState({
        ...state,
        gradientTop: true,
      });
    }
  };

  const onBottomWaypoint = ({ currentPosition }: Waypoint.CallbackArgs) => {
    if (currentPosition === 'inside') {
      setState({
        ...state,
        gradientBottom: false,
      });
    } else if (currentPosition === 'below') {
      setState({
        ...state,
        gradientBottom: true,
      });
    }
  };

  const { gradientBottom, gradientTop } = state;

  return (
    <StyledContainer>
      <GradientListTop visible={gradientTop} />
      <Waypoint onPositionChange={onTopWaypoint} />
      {children}
      <Waypoint onPositionChange={onBottomWaypoint} />
      <GradientListBottom visible={gradientBottom} />
    </StyledContainer>
  );
};
